module.exports = __webpack_public_path__ + "img/CRT_Spear-006.49794af7.png";